import React from "react";
import { CheckIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "../ui";

const VARIANTS = {
  success: { icon: CheckIcon, ring: "border-primary text-primary bg-primary/10", glow: "bg-primary/20" },
  error: { icon: ExclamationTriangleIcon, ring: "border-red-500 text-red-500 bg-red-500/10", glow: "bg-red-500/20" },
};

/** Модалка результату оформлення (успіх / помилка). */
const ResultModal = ({ variant = "success", title, text, children, actionLabel, onAction }) => {
  const { icon: Icon, ring, glow } = VARIANTS[variant];

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/70 backdrop-blur-sm p-6">
      <div
        role="alertdialog"
        aria-label={title}
        className="w-full max-w-sm bg-slate-900 rounded-3xl shadow-2xl border border-slate-700 flex flex-col items-center p-8 text-center"
      >
        <div className="relative mb-8">
          <div className={`absolute inset-0 blur-3xl rounded-full ${glow}`} />
          <div className={`relative flex h-24 w-24 items-center justify-center rounded-full border-4 ${ring}`}>
            <Icon className="w-12 h-12" />
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-3 text-white">{title}</h2>
        {text && <p className="text-slate-400 mb-6">{text}</p>}
        {children}

        <Button
          variant={variant === "error" ? "danger" : "primary"}
          size="lg"
          block
          className={variant === "error" ? "!bg-red-500 !text-white" : ""}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      </div>
    </div>
  );
};

export default ResultModal;
